<div class="login-bg">
  <div class="login-shell animate-fade">
    <section class="login-brand-panel">
      <div class="login-brand-panel__inner">
        <div class="login-brand-panel__glow" aria-hidden="true"></div>
        <img src="assets/icon/logoInstitucion.svg" alt="Logo INE" class="login-logo" />

        <div class="login-brand-panel__license">
          <i class="bi bi-patch-check"></i>
          <span>{{ licenciaDescripcion() }}</span>
        </div>
      </div>
    </section>

    <section class="login-form-panel">
      <div class="login-form-panel__header">
        <h1>Iniciar sesión</h1>
        <p>Ingrese sus credenciales para continuar.</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="form-group">
          <label>
            <i class="bi bi-person-badge"></i>
            <span>Usuario</span>
          </label>

          <div class="input-shell">
            <span class="input-icon" aria-hidden="true">
              <i class="bi bi-person"></i>
            </span>
            <input
              #usernameInput
              type="text"
              formControlName="username"
              placeholder="Ingrese su usuario"
              autofocus
              [class.invalid]="form.controls.username.invalid && form.touched" />
          </div>
        </div>

        <div class="form-group">
          <label>
            <i class="bi bi-shield-lock"></i>
            <span>Contraseña</span>
          </label>

          <div class="input-shell password-wrap">
            <span class="input-icon" aria-hidden="true">
              <i class="bi bi-key"></i>
            </span>
            <input
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="password"
              placeholder="Ingrese su contraseña"
              [class.invalid]="form.controls.password.invalid && form.touched" />

            <button
              type="button"
              class="toggle-pass"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              [attr.title]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <i class="bi" [class.bi-eye]="!showPassword()" [class.bi-eye-slash]="showPassword()"></i>
            </button>
          </div>
        </div>

        <button class="btn-login" type="submit" [disabled]="loading()">
          @if (loading()) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span>Ingresando...</span>
          } @else {
            <i class="bi bi-box-arrow-in-right"></i>
            <span>Ingresar</span>
          }
        </button>

        @if (showAlert()) {
          <app-alert-card [message]="alertMessage()" [type]="alertType()" (closed)="showAlert.set(false)">
          </app-alert-card>
        }

        <div class="form-options">
          <a class="forgot" routerLink="/forgot-password">
            <i class="bi bi-question-circle"></i>
            <span>¿Olvidó su contraseña?</span>
          </a>
        </div>
      </form>

      <div class="card-footer">
        © {{ currentYear }}
      </div>
    </section>
  </div>
</div>
